<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')" [user1Visible]="true"
  [userCaption1]="'上傳附件'" [user2Visible]="true" [userCaption2]="'發MAIL'" [user2Visible]="true" [userCaption3]="'說明'">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <mat-toolbar>
      <button mat-stroked-button color="primary" (click)="doUploadMinio()">
        <mat-icon>upload</mat-icon>
        <span>附件</span>
      </button>
      <button mat-stroked-button color="accent" (click)="doUpload(item)">
        <mat-icon>upload</mat-icon>
        <span>附件[舊版]</span>
      </button>
      <button mat-stroked-button color="primary" (click)="srv.doMail(item)">
        <mat-icon>mail</mat-icon>
        <span>發MAIL</span>
      </button>
      <button mat-stroked-button color="primary" (click)="srv.doHelp()">
        <mat-icon>info</mat-icon>
        <span>說明</span>
      </button>
    </mat-toolbar>
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-mtrwb-tabedit [srv]="srv"></app-mtrwb-tabedit> -->
    <app-jkcheckbox label="系統管理員" [value]="srv.isAdmin" [readonly]="true">
    </app-jkcheckbox>

    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
        <app-jktext label="單號" [value]="item.WB002">
        </app-jktext>
        <app-jkdatefield label="單據日期" #WB004Com id="WB004" [(value)]="item.WB004" [readonly]="true">
        </app-jkdatefield>
        <app-jktext label="反應者姓名" [value]="item.WB005">
        </app-jktext>
        <app-jktext label="EMAIL" [value]="item.WB016">
        </app-jktext>
        <app-jkcheckboxYN label="有附件" #WB025Com id="WB025" [(valueYN)]="item.WB025" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jkcombobox label="類別" #WB007Com id="WB007" [(value)]="item.WB007" [items]="srv.MtrWb007List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jktext label="程式代號" [value]="item.WB008">
        </app-jktext>
        <app-jktext label="程式名稱" [value]="item.WB009">
        </app-jktext>
        <app-jktext label="問題敘述說明" [value]="item.WB010">
        </app-jktext>
        <app-jktext label="處理說明" [value]="item.WB011">
        </app-jktext>
        <app-jkdatefield label="User預計完工日" #WB022Com id="WB022" [(value)]="item.WB022" [readonly]="true">
        </app-jkdatefield>
        <app-jkdatefield label="預計完工日" #WB015Com id="WB015" [(value)]="item.WB015" [readonly]="true">
        </app-jkdatefield>
        <app-jkcombobox label="部門" #WB006Com id="WB006" [(value)]="item.WB006" [items]="srv.MtrWb006List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jkcombobox label="處理順序" #WB012Com id="WB012" [(value)]="item.WB012" [items]="srv.MtrWb012List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jkcombobox label="狀態碼" #WB013Com id="WB013" [(value)]="item.WB013" [items]="srv.MtrWb013List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jkcheckboxYN label="結案碼" #WB014Com id="WB014" [(valueYN)]="item.WB014" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jkdatefield label="預計開工日" #WB020Com id="WB020" [(value)]="item.WB020" [readonly]="true">
        </app-jkdatefield>
        <app-jkdatefield label="交件日" #WB021Com id="WB021" [(value)]="item.WB021" [readonly]="true">
        </app-jkdatefield>
        <app-jktext label="反應者代號" [value]="item.WB003">
        </app-jktext>
        <app-jktext label="客戶代號" [value]="item.WB024">
        </app-jktext>
        <app-jknumberedit label="實際工時" #WB017Com id="WB017" [(value)]="item.WB017" [readonly]="true">
        </app-jknumberedit>
        <app-jknumberedit label="報價工時" #WB018Com id="WB018" [(value)]="item.WB018" [readonly]="true">
        </app-jknumberedit>
        <app-jktext label="訂單單號" [value]="item.WB019">
        </app-jktext>
        <app-jktextarea height="250px" label="傑克程式說明" #WB036Com id="WB036" [(value)]="item.WB036" [readonly]="true">
        </app-jktextarea>
        <app-jktext label="google文件網址" [value]="item.WB037">
        </app-jktext>
        <app-jktext label="序號" [value]="item.WB023">
        </app-jktext>
        <app-jkcheckboxYN label="已報價" #WB026Com id="WB026" [(valueYN)]="item.WB026" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jkcheckboxYN label="已回簽" #WB027Com id="WB027" [(valueYN)]="item.WB027" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jktext label="程式人員" [value]="item.WB028">
        </app-jktext>
        <app-jkcheckboxYN label="已交件" #WB029Com id="WB029" [(valueYN)]="item.WB029" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jknumberedit label="附件數" #WB035Com id="WB035" [(value)]="item.WB035" [readonly]="true">
        </app-jknumberedit>
        <app-jktext label="單別" [value]="item.WB001">
        </app-jktext>
        <app-jktext label="預留欄位" [value]="item.WB030">
        </app-jktext>
        <app-jktext label="預留欄位" [value]="item.WB031">
        </app-jktext>
        <app-jktext label="預留欄位" [value]="item.WB032">
        </app-jktext>
        <app-jktext label="預留欄位" [value]="item.WB033">
        </app-jktext>
        <app-jktext label="預留欄位" [value]="item.WB034">
        </app-jktext>

      </div>
    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-50]">[空白]</div>
  </mat-tab>
</mat-tab-group>
